(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ab-market-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ab-market-selector')) {
    customElements.define('ab-market-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('submit', (event) => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          const destination = new URL(window.location.href);
          destination.searchParams.delete('country');
          destination.searchParams.delete('currency');
          let returnInput = form.querySelector('input[name="return_to"]');
          if (!returnInput) {
            returnInput = document.createElement('input');
            returnInput.type = 'hidden';
            returnInput.name = 'return_to';
            form.append(returnInput);
          }
          returnInput.value = destination.pathname + destination.search;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
